const state = {
  banner: {
    activeIndex: null
  }
}

const getters = {
  bannerActiveIndex: state => state.banner.activeIndex
}

const mutations = {
  SET_BANNER_ACTIVE_INDEX (state, activeIndex) {
    state.banner.activeIndex = activeIndex
  }
}

const actions = {
  setBannerActiveIndex ({ commit }, activeIndex) {
    console.warn('set', activeIndex)
    commit('SET_BANNER_ACTIVE_INDEX', activeIndex)
  }
}

export default { state, getters, mutations, actions }
